import { FlexContainer, Text } from '@taxdown/piccolo-web';
import styled, { css } from 'styled-components';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const Container = styled(FlexContainer)`
  padding: ${({ theme: { sizing } }) => ` ${sizing.fds_size_16} 0`};
  max-width: 480px;
`;

export const Section = styled(FlexContainer)`
  ${({ borderBottomOnly }) =>
    !borderBottomOnly &&
    css`
      border-top: 1px solid ${({ theme }) => theme.colors.moon_500};
    `};
  border-bottom: 1px solid ${({ theme }) => theme.colors.moon_500};
  padding: ${({ theme }) => `${theme.sizing.fds_size_16} ${theme.sizing.fds_size_08}`};
`;

export const Message = styled(Text)`
  padding: ${({ theme }) => theme.sizing.fds_size_16};
  background-color: ${({ theme }) => theme.colors.moon_300};
  border-radius: ${({ theme: { sizing } }) => sizing.fds_borderradius_S};
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const SocialLink = styled.a`
  cursor: pointer;
`;

export const CopyButton = styled.button`
  max-width: 50px;
  cursor: pointer;
`;

export const Icon = styled.img`
  width: ${({ theme }) => theme.sizing.fds_size_32};
  height: ${({ theme }) => theme.sizing.fds_size_32};
`;

export const ModalContainer = styled(FlexContainer)`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 99;
  background: ${({ theme: { colors } }) => colors.darken};
`;

export const ModalContent = styled(FlexContainer)`
  position: relative;
  background-color: ${({ theme: { colors } }) => colors.white};
  border-radius: ${({ theme: { sizing } }) => sizing.fds_borderradius_M};
  width: ${({ width }) => css`
    ${width}
  `};
  padding: ${({ theme: { sizing } }) => sizing.fds_size_16};
  max-height: 650px;
  overflow: scroll;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    min-width: 90%;
    max-width: 90%;
  }
`;

export const CloseButton = styled.button`
  cursor: pointer;

  svg {
    width: ${({ theme: { sizing } }) => sizing.fds_size_16};
    height: ${({ theme: { sizing } }) => sizing.fds_size_16};
  }
`;

export const Banner = styled(FlexContainer)`
  width: 100%;
  background: ${({ theme: { components } }) => components.messages.fds_c_messages_success};
  padding: ${({ theme }) => theme.sizing.fds_size_16};
  span {
    font-weight: bold;
    color: ${({ theme: { components } }) => components.paragraphs.success_strong};
  }
  ul {
    list-style: inside;
  }
`;
